import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LandingPageComponent } from "./components/landing-page/landing-page.component";
import { LayoutComponent } from "./layout/layout.component";
import { ReportHistoryComponent } from "./components/report-history/report-history.component";
import { NgoDiligenceComponent } from "./components/ngo-diligence/ngo-diligence.component";
import { UserProfileComponent } from "./components/user-profile/user-profile.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { ProfileCompleteGuard } from "./core/guards/profile-complete.guard";

const routes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [ProfileCompleteGuard],
    children: [
      {
        path: "", component: LandingPageComponent, title: "Radar",
        data: { skipProfileGuard: true, skipAuthGuard: true }
      },
      { path: "home", redirectTo: "", pathMatch: "full" },
      {
        path: "ngo-diligence",
        component: NgoDiligenceComponent,
        title: "NGO Diligence",
      },
      {
        path: "ngo-diligence/:txnId",
        component: NgoDiligenceComponent,
        title: "NGO Diligence",
      },
      {
        path: "report-history",
        component: ReportHistoryComponent,
        title: "Reports History",
      },
      {
        path: "user/profile",
        component: UserProfileComponent,
        title: "Profile Information",
        data: { skipProfileGuard: true }
      },
    ],
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./components/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "admin",
    loadChildren: () =>
      import("./components/admin/admin.module").then((m) => m.AdminModule),
  },
  {
    path: "**",
    redirectTo: "",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
      scrollOffset: [0, 0],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
